import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';

import { renderYearsArray, isLaterThanWeekAfterToday } from '../services/utils';

import appConfig from '../config/app-config';

import * as appActions from '../actions/appActions';
import * as indicesActions from '../actions/indicesActions';

import IndexSettlement from '../components/indexSettlement';
import ManageIndicesTable from '../components/manageIndices/manageIndicesTable';
import { getIsPageVisible } from '../selectors/mainSelectors';
import { getIndicesPreviewProducts } from '../selectors/indicesSelectors';
import { IndicesFrequency } from '../constants/indices';

const { initialYear } = appConfig;
const years = renderYearsArray(initialYear);

class ManageIndices extends React.Component {
    componentDidMount() {
        this.props.getMarketsListWithProducts();
        this.props.getAllIndices();
        this.props.setYear(years[0]);
        this.updateSchedule(this.props);
    }

    componentWillReceiveProps(nextProps) {
        this.updateSchedule(nextProps);
    }

    componentWillUnmount() {
        this.props.setMarketId('');
        this.props.setFrequencyType('');
        this.props.setYear('');
    }

    updateSchedule = props => {
        const { markets, marketId, scheludeUpdated } = props;

        if (markets.length && (!marketId || scheludeUpdated)) {
            this.props.scheduleShouldBeUpdated(false);
            this.props.setMarketId(markets[0].id);
            this.props.getFullSchedule(markets[0].id, this.props.year || years[0]);
        }
    };

    onChange = e => {
        const { value, name } = e.target;
        const { marketId, year } = this.props;

        if (name === 'year') {
            this.props.setYear(value);
            this.props.getFullSchedule(marketId, value);
        } else {
            this.props.setMarketId(value);
            this.props.getFullSchedule(value, year);
        }
    };

    showPopup = (date, frequencyType) => {
        const selectedDate = date || this.getClosestDate();

        this.props.setSelectedDate(selectedDate);
        this.props.setFrequencyType(frequencyType);
        this.props.showIndicesPopup();
    };

    getClosestDate = dates => {
        const selectedDates = dates || [];
        const curYear = new Date().getFullYear();

        if (this.props.year < curYear) {
            return selectedDates[0];
        }

        return selectedDates.find(d => !isLaterThanWeekAfterToday(d));
    };

    render() {
        const { isSuperUser, isLoggedIn, markets, products, indicesShedule } = this.props;
        const dailyProducts = products ? products.filter(p => p.indices_frequency_type === IndicesFrequency.DAILY) : [];

        const dailyShedule = indicesShedule[IndicesFrequency.DAILY];
        const weeklyShedule = indicesShedule[IndicesFrequency.WEEKLY];

        return isLoggedIn ? (
            <div className="indices-container">
                <div className="indices-header">
                    <h1>{isSuperUser ? 'MANAGE INDICES' : 'INDICES OVERVIEW'}</h1>
                    <div className="indices-market-selector-holder">
                        <div className="column">
                            <div className="indices-market-selector-label">Select market</div>
                            <select
                                className="indices-market-selector"
                                onChange={this.onChange}
                                name="marketId"
                                value={this.props.marketId}
                            >
                                {markets && markets.length
                                    ? markets.map(item => (
                                          <option key={`marksel_${item.id}`} value={item.id}>
                                              {item.name}
                                          </option>
                                      ))
                                    : null}
                            </select>
                        </div>

                        <div className="column">
                            <div className="indices-market-selector-label">Select year</div>
                            <select
                                className="indices-year-selector"
                                onChange={this.onChange}
                                name="year"
                                value={this.props.year}
                            >
                                {years && years.length
                                    ? years.map(item => (
                                          <option key={`year_${item}`} value={item}>
                                              {item}
                                          </option>
                                      ))
                                    : null}
                            </select>
                        </div>
                    </div>
                </div>

                {dailyProducts && dailyProducts.length ? (
                    <ManageIndicesTable
                        indices={this.props.indices}
                        indexClosestDate={this.getClosestDate(dailyShedule ? dailyShedule.selectedDates : [])}
                        products={dailyProducts}
                        indicesShedule={dailyShedule}
                        isSuperUser={isSuperUser}
                        showPopup={this.showPopup}
                        frequencyType={IndicesFrequency.DAILY}
                    />
                ) : null}

                <ManageIndicesTable
                    indices={this.props.indices}
                    products={products.filter(p => p.indices_frequency_type === IndicesFrequency.WEEKLY)}
                    indexClosestDate={this.getClosestDate(weeklyShedule ? weeklyShedule.selectedDates : [])}
                    indicesShedule={weeklyShedule}
                    isSuperUser={isSuperUser}
                    showPopup={this.showPopup}
                    frequencyType={IndicesFrequency.WEEKLY}
                />

                {isSuperUser ? (
                    <React.Fragment>
                        <IndexSettlement
                            sendSettlement={this.props.sendSettlement}
                            marketId={this.props.marketId}
                            years={years}
                            initialYear={initialYear}
                            type="settlement"
                        />
                        <IndexSettlement
                            sendSettlement={this.props.sendSettlementReport}
                            marketId={this.props.marketId}
                            years={years}
                            initialYear={initialYear}
                            type="report"
                        />
                    </React.Fragment>
                ) : null}
            </div>
        ) : null;
    }
}

ManageIndices.propTypes = {
    isSuperUser: PropTypes.bool.isRequired,
    isLoggedIn: PropTypes.bool.isRequired,

    getMarketsListWithProducts: PropTypes.func.isRequired,
    getAllIndices: PropTypes.func.isRequired,
    scheduleShouldBeUpdated: PropTypes.func.isRequired,
    showIndicesPopup: PropTypes.func.isRequired,
    sendSettlement: PropTypes.func.isRequired,
    getFullSchedule: PropTypes.func.isRequired,
    sendSettlementReport: PropTypes.func.isRequired,
    setSelectedDate: PropTypes.func.isRequired,
    setFrequencyType: PropTypes.func.isRequired,
    setYear: PropTypes.func.isRequired,
    setMarketId: PropTypes.func.isRequired,

    markets: PropTypes.arrayOf(PropTypes.shape({})),
    products: PropTypes.arrayOf(PropTypes.shape({})),
    indices: PropTypes.shape({}),
    indicesShedule: PropTypes.shape({}).isRequired,

    marketId: PropTypes.string.isRequired,
    year: PropTypes.number,
};

ManageIndices.defaultProps = {
    year: '',
    indices: {},
    markets: [],
    products: [],
};

export default connect(
    state => ({
        indices: state.indices.data,
        indicesShedule: state.indices.indicesShedule,
        marketsList: state.indices.marketsList,
        markets: state.markets.data,
        user: state.user,
        products: getIndicesPreviewProducts(state),
        isLoggedIn: state.user.isLoggedIn,
        isSuperUser: getIsPageVisible(state),
        marketId: state.indices.market_id,
        year: state.indices.year,
        scheludeUpdated: state.indices.scheludeUpdated,
    }),
    dispatch => ({
        ...bindActionCreators({ ...appActions, ...indicesActions }, dispatch),
    }),
)(ManageIndices);



// WEBPACK FOOTER //
// ./source/screens/ManageIndices.js